import { Field, TextArea } from "@nabble/ui";
import { DETAILS_MAX } from "../../../model/dataRequests";
import type { RequestDrawerState } from "./useRequestDrawer";

/** The reason for extending the deadline, which the person receives by email. */
export function ExtensionField({ drawer }: { drawer: RequestDrawerState }): React.JSX.Element {
  return (
    <Field
      label="Why do you need more time?"
      help="Adds 30 days. The person receives the reason by email. A deadline can be extended only once."
      error={drawer.textError ?? undefined}
    >
      <TextArea value={drawer.text} onChange={(e) => drawer.setText(e.target.value)} rows={4} maxLength={DETAILS_MAX} autoFocus />
    </Field>
  );
}
